/** @jsxImportSource @emotion/react */
import {
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { css } from "@emotion/react";
import { useState } from "react";
import { useEffect } from "react";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";

const dropdown = css`
  margin-bottom: 20px;
  button {
    border-radius: unset;
    color: white;
  }
  .MuiOutlinedInput-root {
    padding: 2px;
    color: white;
    font-size: 16px;
    background-color: #2e2e2e;
  }
  .MuiOutlinedInput-input {
    height: 1.5rem;
  }
  .MuiAutocomplete-option {
    color: black;
  }
`;

export default function TableComponent({ tableData, characteristics }) {
  const [value, setValue] = useState("");
  const [tableOptions, setTableOptions] = useState([]);
  const [charValue, setCharValue] = useState("");
  const [charOptions, setCharOptions] = useState([]);
  const [dataObj, setDataObj] = useState({});
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  useEffect(() => {
    const obj = {};
    const arr = characteristics.map((item) => item?.attributes?.characteristic);
    const arr1 = tableData.map((item) => {
      obj[item.attributes.title] = item.attributes.truckTableRows;
      return item?.attributes?.title;
    });
    setCharValue(arr[0]);
    setValue(arr1[0]);
    setCharOptions([...arr]);
    setTableOptions([...arr1]);
    setDataObj((prevState) => ({
      ...prevState,
      ...obj,
    }));
  }, []);

  const setNewValue = (event, newValue) => {
    setValue(newValue);
  };

  const changeCharValue = (event, newValue) => {
    setCharValue(newValue);
  };

  return (
    <>
      {matches ? (
        <TableContainer style={{ padding: "5%" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "25%" }}>
                  <Autocomplete
                    disableClearable
                    value={value}
                    options={tableOptions}
                    css={dropdown}
                    onChange={setNewValue}
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                  ></Autocomplete>
                </TableCell>
                <TableCell style={{ width: "25%" }}>
                  <Autocomplete
                    disableClearable
                    value={charValue}
                    options={charOptions}
                    css={dropdown}
                    onChange={changeCharValue}
                    sx={{ width: "100%" }}
                    renderInput={(params) => <TextField {...params} />}
                  ></Autocomplete>
                </TableCell>
                <TableCell style={{ width: "50%" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataObj?.[value]?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell style={{ color: "white" }}>
                    {item.firstParameter}
                  </TableCell>
                  <TableCell style={{ color: "white" }}>
                    {item.secondParameter}
                  </TableCell>
                  <TableCell style={{ color: "white" }}>
                    {item.description}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box p={3} style={{ width: "100%" }}>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Autocomplete
              disableClearable
              value={value}
              options={tableOptions}
              css={dropdown}
              onChange={setNewValue}
              sx={{ width: "47%" }}
              renderInput={(params) => <TextField {...params} />}
            ></Autocomplete>
            <Autocomplete
              disableClearable
              value={charValue}
              options={charOptions}
              css={dropdown}
              onChange={changeCharValue}
              sx={{ width: "47%" }}
              renderInput={(params) => <TextField {...params} />}
            ></Autocomplete>
          </Box>
          {dataObj?.[value]?.map((item, index) => (
            <Box key={index} pb={3}>
              <Typography style={{ color: "white" }} variant="h6">
                {item.firstParameter}
              </Typography>
              <Typography style={{ color: "white" }} variant="h6">
                {item.secondParameter}
              </Typography>
              <Typography
                pt={1}
                style={{ fontSize: "14px", lineHeight: "35px" }}
                variant="body1"
              >
                {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
}
